import React from "react";
import {
//   BrowserRouter as Router,
  useParams,
} from "react-router-dom";
import Tendencies from './Tendencies';
import Permutations from './Permutations';
import Probability from './Probability';
import Distributions from "./Distributions";
import StatisticalInference from "./StatisticalInference";
import RegressionAnalysis from "./RegressionAnalysis";
import ErrorAnalysis from './ErrorAnalysis';

const ChangeComponents = {
    tendencies: Tendencies,
    permutations: Permutations,
    probability: Probability,
    distributions: Distributions,
    statisticalinference: StatisticalInference,
    regressionanalysis: RegressionAnalysis,
    erroranalysis: ErrorAnalysis,

  };

export default function Subtopics(props) {
    // The <Route> that rendered this component has a
    // path of `/topics/:topicId`. The `:topicId` portion
    // of the URL indicates a placeholder that we can
    // get from `useParams()`.
    let { topicId } = useParams();
    
    let MyComponent = ChangeComponents[topicId];
    return (
        <div>
            {/* {topicId} is for testing route names */}
            {/* <h3>{topicId}</h3> */}
            <MyComponent topicId={topicId}/>
      </div>
    );
  }